module.exports = __webpack_public_path__ + "img/logo-horizontal.bd146e35.svg";